// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Overlay that covers the entire page with a semi-transparent background */
.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4); /* Semi-transparent background */
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999; /* Ensure the spinner is above other content */
  }
  
  /* Container for spinner and text */
  .spinner-container {
    text-align: center;
  }
  
  /* Loading text styling */
  .loading-text {
    font-size: 20px;
    font-weight: bold;
    color: #333;
    margin-top: 16px; /* Space between spinner and text */
  }
  `, "",{"version":3,"sources":["webpack://./src/components/LoadingSpinner.css"],"names":[],"mappings":"AAAA,2EAA2E;AAC3E;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B,EAAE,gCAAgC;IAChE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa,EAAE,8CAA8C;EAC/D;;EAEA,mCAAmC;EACnC;IACE,kBAAkB;EACpB;;EAEA,yBAAyB;EACzB;IACE,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,gBAAgB,EAAE,mCAAmC;EACvD","sourcesContent":["/* Overlay that covers the entire page with a semi-transparent background */\n.loading-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.4); /* Semi-transparent background */\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 9999; /* Ensure the spinner is above other content */\n  }\n  \n  /* Container for spinner and text */\n  .spinner-container {\n    text-align: center;\n  }\n  \n  /* Loading text styling */\n  .loading-text {\n    font-size: 20px;\n    font-weight: bold;\n    color: #333;\n    margin-top: 16px; /* Space between spinner and text */\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
